import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { addToCart } from "../../../redux/actions/CartActions";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Loader from "../../../components/loader/Loader";
import FormalityHeader from "../../../components/header/FormalityHeader";
import { createPassportRequest } from "../../../redux/actions/FormalityActions";
import Swal from "sweetalert2";
import "../../styles/flow-form.css";

// Validation schema
const validationSchema = Yup.object({
  passportType: Yup.string().required("Le pays est requis"),
  destination: Yup.string().required("La destination est requise"),
  reason: Yup.string().required("Le motif est requis"),
});

const typeData = [
  { label: "Premier passeport", value: "first_time" },
  { label: "Passeport périmé", value: "expired" },
  { label: "Passeport perdu", value: "lost" },
  { label: "Passeport volé", value: "stolen" },
  { label: "Passeport détérioré", value: "damaged" },
  { label: "Changement de filiation", value: "affiliation_change" },
  { label: "Changement de nom", value: "name_change" },
  { label: "Correction", value: "correction" },
  { label: "Passeport plein", value: "full_passport" },
  { label: "Passeport supplementaire", value: "additional_passport" },
];

function PassportType() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const [submitting, setSubmitting] = useState(false);
  const { user } = useSelector((state) => state.authUser);

  const handleSubmit = async (values) => {
    setSubmitting(true);
    await dispatch(
      addToCart({
        passportType: values.passportType,
        destination: values.destination,
        reason: values.reason,
      })
    );

    await dispatch(
      createPassportRequest(
        user.token,
        {
          passportType: values.passportType,
        },
        handleCallback
      )
    );
  };

  const handleCallback = ({ success, message }) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
    });
    if (success) {
      navigate("/passport-birth-place");
    } else {
      Toast.fire({
        icon: "error",
        title: "Échec",
        text: message,
      });
    }
    setSubmitting(false);
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />
      <Loader isLoading={submitting} />

      <div className="container mt-3 text-center" style={{ maxWidth: "800px" }}>
        <h4 className="text-center mt-4 mb-4">
          <span style={{ color: "#FF5500" }}>Type</span> de demande
        </h4>
      </div>

      <div className="container mt-4 d-flex justify-content-center">
        <Formik
          initialValues={{ reason: "", passportType: "", destination: "" }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, values, errors, touched }) => (
            <Form
              className="w-100"
              style={{ textAlign: "left", maxWidth: "400px" }}
            >
              {/* City selector */}
              <div className="mb-3">
                <Select
                  options={typeData || []}
                  value={typeData?.find((type) => type.label === values.type)}
                  onChange={(selected) =>
                    setFieldValue("passportType", selected.value)
                  }
                  placeholder="Type de demande"
                  isSearchable
                  style={{ height: "50px" }}
                />
                {errors.passportType && touched.passportType && (
                  <div className="text-danger">{errors.passportType}</div>
                )}
              </div>

              <div className="mb-3">
                <Field
                  name="destination"
                  className="form-control"
                  placeholder="Destination prévue"
                  style={{ height: "50px" }}
                />
                {errors.destination && touched.destination && (
                  <div className="text-danger">{errors.destination}</div>
                )}
              </div>

              <div className="mb-3">
                <Field
                  name="reason"
                  className="form-control"
                  placeholder="Motif de deplacement"
                  style={{ height: "50px" }}
                />
                {errors.reason && touched.reason && (
                  <div className="text-danger">{errors.reason}</div>
                )}
              </div>

              {/* Submit button */}
              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "10px",
                    color: "#fff",
                    width: "180px",
                    padding: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default PassportType;
